import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {userRegister} from "../../services/userRegister";
import TextareaAutosize from 'react-autosize-textarea';
import {langRegister} from "../../services/langRegister";
import innerHtml from 'react-inner-html';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {scraperRegister} from "../../services/scraperRegister";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";

class SignupQuotes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: null,
            quotes: [],
            selected: {},
            isLoadingButton: false,
            isLoading: true,
            page: 1,
            page_load: 5,
            admin: false,
            customQuote: {
                selected: false,
                saved: false,
                text: "",
                modal: false,
                custom: true
            },
            customCount: 0,
            error: false,
            sale: "instant"
        };
        this._renderAdminQuote = this._renderAdminQuote.bind(this);
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._updateUser();

        if(window.innerWidth > 1050){
            this.setState({page_load: 10}, () => {
                this._updateData();
            });
        }else{
            this.setState({page_load: 8}, () => {
                this._updateData();
            });
        }

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/quotes-custom');
            ReactGA4.send({ hitType: "pageview", page: "/signup/quotes-custom" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        //CHECK VIEW
        let view = quotesRegister.getView();
        if(!view){
            cartRegister.setQuotes(null);
        }
        quotesRegister.setView("custom");

    }

    _updateUser() {
        try {
            let user = userRegister.get();
            if (user) {
                this.setState({admin: user.reseller || user.inhouse, inhouse: user.inhouse});
            }
        } catch (error) {
            this.setState({
                error: true
            });
        }
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();

            //SET SALE TYPE
            this.setState({sale:stored_data.crossroad});

            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
                }
            }
            if (stored_data.industry && (stored_data.image || stored_data.admin_image)) {
                this.setState({
                    industry: stored_data.industry
                }, () => {
                    this._updateQuotes(this.state.industry.id, salesChannelRegister.get('market'), langRegister.lang());
                });
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image");
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuotes(industry, market, lang) {
        try {
            let stored_quotes = null;//quotesRegister.get();
            let stored_page = null; //quotesRegister.page();
            if (stored_quotes) {
                this.setState({
                    quotes: stored_quotes,
                    page: stored_page,
                    isLoading: false
                }, () => {
                    this._updateQuote();
                });
            } else {
                dataRegister.quotes(industry, market, lang).then((data) => {
                    if (data.errors) {
                        this.setState({
                            isLoading: false
                        });
                    } else {
                        let quotes = data;

                        //REMOVE INDUSTRY SLOGANS
                        let industry_slogans = [];
                        let other_quotes = [];
                        for(let i = 0; i < quotes.length; i++){
                            if(quotes[i].slogan.indexOf(this.state.industry.name) !== -1){
                                industry_slogans.push(quotes[i]);
                            }else{
                                other_quotes.push(quotes[i]);
                            }
                        }

                        other_quotes.sort(function(a, b) {
                            var textA = a.slogan.toUpperCase();
                            var textB = b.slogan.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });

                        /*
                        //ADD SCRAPED SLOGANS
                        let scraped_data = JSON.parse(scraperRegister.get());
                        let scraped_data_length = 0;
                        try{
                            scraped_data_length = scraped_data.slogans.length;
                            for(let i = 0; i < scraped_data.slogans.length; i++){
                                industry_slogans.unshift({
                                    slogan: scraped_data.slogans[i],
                                    id: "scraped_" + i,
                                    custom: true,
                                    scraped: true,
                                    sale: "both",
                                    type: "both",
                                    index: 0
                                });
                            }
                        }catch (e) {}
                        */

                        industry_slogans = industry_slogans.concat(other_quotes);

                        let custom = quotesRegister.getCustom();
                        if(custom){
                            industry_slogans = custom.concat(industry_slogans);
                        }

                        this.setState({
                            quotes: industry_slogans,
                            customCount: custom.length,
                            isLoading: false
                        }, () => {
                            quotesRegister.set(this.state.quotes, 1, lang);
                            this._updateQuote();
                        });
                    }

                }, (error) => {
                    this.setState({error: true});
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateQuote() {
        try {
            let stored_quotes = cartRegister.get();
            if (stored_quotes.quotes) {
                this.setState({
                    selected: stored_quotes.quotes
                }, () => {
                    //FILTER BY SELECTED QUOTES
                    let quotes = [];
                    let selected = [];
                    let scraped_count = 0;
                    for(let i = 0; i < this.state.quotes.length; i++){
                        if(this.state.selected[this.state.quotes[i].id]){
                            selected.push(this.state.quotes[i]);
                        }else{
                            quotes.push(this.state.quotes[i]);
                        }
                    }
                    selected.sort(function(a, b) {
                        return a.index - b.index;
                    });
                    selected = selected.concat(quotes);
                    this.setState({
                        quotes: selected
                    });
                });
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _selectQuote(prop) {
        try {
            if (!this.state.isLoading) {
                if (this.state.customQuote.selected) {
                    this.state.customQuote.selected = false;
                    this.setState({
                        customQuote: this.state.customQuote
                    });
                }
                if (this.state.selected[prop.id]) {
                    delete this.state.selected[prop.id];
                    prop.selected = false;
                    this.setState({
                        selected: this.state.selected,
                        quotes: this.state.quotes
                    }, () => {
                        videoRegister.remove();
                        carouselRegister.remove();
                        cartRegister.setQuotes(this.state.selected);
                    });

                } else {
                    if (Object.keys(this.state.selected).length > 3) {
                        videoRegister.remove();
                        carouselRegister.remove();
                        cartRegister.setQuotes(this.state.selected);
                        quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
                    } else {
                        prop.selected = true;
                        this.state.selected[prop.id] = prop;
                        let index = 0;
                        for(let key in this.state.selected){
                            if(this.state.selected[key].index && this.state.selected[key].index > index){
                                index = this.state.selected[key].index;
                            }
                        }
                        index++;
                        this.state.selected[prop.id].index = index;
                        this.setState({
                            selected: this.state.selected,
                            quotes: this.state.quotes
                        }, () => {
                            videoRegister.remove();
                            carouselRegister.remove();
                            cartRegister.setQuotes(this.state.selected);
                            if (Object.keys(this.state.selected).length > 3) {
                                quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
                            }
                        });
                    }
                }
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _setCustomQuote(){
        try {
            let words = this.state.customQuote.text.split(" ");
            for(let i = 0; i < words.length; i++){
                words[i] = capitalizeFLetter(words[i]);
            }
            this.state.customQuote.text = words.join(" ");
        }catch (e) {
            console.log(e);
        }
        let slogan = {
            slogan: this.state.customQuote.text,
            id: window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16),
            custom: true,
            sale: "both",
            type: "both",
            index: 0
        };
        this.state.quotes.unshift(slogan);
        this.setState({quotes: this.state.quotes, customCount: this.state.customCount + 1}, () => {
            quotesRegister.setCustomQuote(slogan);
        });
        function capitalizeFLetter(string) {
            return  string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

    _addCustomQuote() {
        try {
            this.state.customQuote.modal = true;
            this.state.customQuote.text = "";
            this.setState({
                customQuote: this.state.customQuote
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _moreQuotes() {
        try {
            this.setState({page_load: window.innerWidth > 1050?5:4}, () => {
                this.setState({
                    page: this.state.page + (this.state.page === 1?2:1)
                }, () => {
                    console.log(this.state.page);
                    this._scrollTo("bottom");
                    quotesRegister.set(this.state.quotes, this.state.page, langRegister.lang());
                });
            });
        } catch (error) {
            this.setState({error: true});
        }
    }

    _next(){
        if(Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved){
            if(this.state.customQuote.saved && this.state.customQuote.selected){
                cartRegister.setAdAdminQuotes(this.state.customQuote);
            }
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/business");
        }
    }

    _scrollTo(element) {
        let offSet = 0, timeout = null;
        element = document.getElementById(element);
        if (element) {
            const elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
            window.scroll({top: elemPos + offSet, left: 0, behavior: 'smooth'});
        }
    }

    _renderAdminQuote(e){
        try{
            const re = /^[\x00-\xFF]*$/;
            if (e.target.value === '' || re.test(e.target.value)) {
                this.state.customQuote.text = e.target.value;
                this.setState({customQuote: this.state.customQuote});
            }
        }catch (e) {
            console.log(e);
        }
    }

    _renderQuote(slogan){
        try {
            let string = slogan.replace(this.state.industry.name, '<bold><div>&nbsp;'+this.state.industry.name+'&nbsp;</div></bold>');
            return (<span {...innerHtml(string)}></span>);
        }catch (error) {
            return slogan;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-quotes", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne history={this.props.history} view={"signup"} props={this.props}/>

                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        {
                            !this.state.error &&
                            <div className={Styles.title}>
                                {
                                    this.state.customQuote.modal &&
                                    <div>
                                        {this._renderText("item_5")}
                                    </div>
                                    ||
                                    <div>
                                        {this._renderText("item_1")}
                                    </div>
                                }
                            </div>
                        }
                        {
                            !this.state.error &&
                            <div className={Styles.quotesContainer}>
                                {
                                    !this.state.customQuote.modal && (this.state.admin || this.state.inhouse) &&
                                    <div
                                        onClick={() => this._addCustomQuote()}
                                        className={Styles.quotesContainerItem}>
                                        <div className={Styles.quotesContainerItemQuote}>
                                            <div className={Styles.quotesContainerItemQuoteIcon}>
                                                +
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    !this.state.customQuote.modal &&
                                    this.state.quotes.filter((item) => {
                                        return (item.sale === this.state.sale || item.sale === "both")
                                    }).filter((item) => {
                                        return (item.type === "both" || (item.type === "service" && +this.state.industry.type === 1) || (item.type === "product" && +this.state.industry.type === 2))
                                    }).filter((item, i) => {
                                        if(this.state.admin && this.state.page === 1){
                                            if(window.innerWidth > 1050){
                                                return i < 4 + this.state.customCount
                                            }else{
                                                return i < 5 + this.state.customCount
                                            }
                                        }else if(this.state.admin){
                                            return i < (this.state.page * this.state.page_load - 1) + this.state.customCount
                                        }else{
                                            return i < (this.state.page * this.state.page_load) + this.state.customCount
                                        }
                                    }).map((prop, i) => {
                                        return (
                                            <div key={i}
                                                 onClick={() => this._selectQuote(prop)}
                                                 className={
                                                     cx(Styles.quotesContainerItem,
                                                         {
                                                             [Styles.quotesContainerItemActive]: this.state.selected[prop.id],
                                                         })
                                                 }>
                                                <div className={Styles.quotesContainerItemQuote}>
                                                    {this._renderQuote(prop.slogan)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    this.state.customQuote.modal &&
                                    <div className={Styles.customQuote}>
                                        {
                                            false &&
                                            <input
                                                value={this.state.customQuote.text}
                                                onChange={this._renderAdminQuote}
                                                placeholder={this._renderText("item_6")}
                                                maxLength={30}
                                                className={Styles.customQuoteTextArea}
                                            />
                                        }
                                        <input
                                            maxLength={30}
                                            value={this.state.customQuote.text}
                                            onChange={(event) => {
                                                String.prototype.allReplace = function (obj) {
                                                    var retStr = this;
                                                    for (var x in obj) {
                                                        try {
                                                            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
                                                        } catch (e) {
                                                        }
                                                    }
                                                    return retStr;
                                                };
                                                let string = event.target.value.allReplace({
                                                    '!': '',
                                                    '&': '',
                                                    ';': '',
                                                    '_': '',
                                                    '`': '',
                                                    '+': '',
                                                    '≈': '',
                                                    '[': '',
                                                    ']': '',
                                                    '|': '',
                                                    '§': '',
                                                    '∞': '',
                                                    '$': '',
                                                    '£': '',
                                                    '©': '',
                                                    '#': '',
                                                    '€': '',
                                                    '%': '',
                                                    '=': '',
                                                    ')': '',
                                                    '(': '',
                                                    '/': '',
                                                    '{': '',
                                                    '}': ''
                                                });
                                                this.state.customQuote.text = string;
                                                this.setState({customQuote: this.state.customQuote});
                                            }}
                                            className={Styles.customQuoteTextArea}
                                            placeholder={this._renderText("item_6")}
                                        />
                                        {
                                            this.state.customQuote.modal &&
                                            <div className={Styles.customQuoteButtons}>
                                                <div className={Styles.customQuoteButtonsItem}>
                                                    <div onClick={() => {
                                                        this.state.customQuote.text = "";
                                                        this.state.customQuote.saved = false;
                                                        this.state.customQuote.modal = false;
                                                        this.state.customQuote.selected = false;
                                                        this.setState({customQuote: this.state.customQuote})
                                                    }} className={Styles.customQuoteButtonsItemRemove}>
                                                        <img className={Styles.customQuoteButtonsItemRemoveIcon}
                                                             src={require("../../assets/images/AB_cross_bold.png")}/>
                                                    </div>
                                                </div>
                                                <div className={Styles.customQuoteButtonsItem}>
                                                    <div
                                                        onClick={() => {
                                                            if (this.state.customQuote.text !== "") {
                                                                this.state.customQuote.saved = true;
                                                                this.state.customQuote.modal = false;
                                                                this.setState({
                                                                    customQuote: this.state.customQuote
                                                                }, () => {
                                                                    this._setCustomQuote()
                                                                })
                                                            }
                                                        }
                                                        }
                                                        className={
                                                            cx(Styles.customQuoteButtonsItemSave,
                                                                {
                                                                    [Styles.customQuoteButtonsItemSaveActive]: this.state.customQuote.text !== "",
                                                                })
                                                        }>
                                                        <img className={Styles.customQuoteButtonsItemRemoveIcon}
                                                             src={require("../../assets/images/AB_checkmark_bold.png")}/>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                        {
                            !this.state.customQuote.modal &&
                            <div onClick={() => this._moreQuotes()} className={
                                cx(Styles.plusIcon,
                                    {
                                        [Styles.plusIconActive]: this.state.quotes.filter((item) => {
                                            return (item.sale === this.state.sale || item.sale === "both")
                                        }).filter((item) => {
                                            return (item.type === "both" || (item.type === "service" && +this.state.industry.type === 1) || (item.type === "product" && +this.state.industry.type === 2))
                                        }).length > (this.state.page * this.state.page_load),
                                    })
                            }>
                                {
                                    this.state.isLoadingButton &&
                                    <BeatLoader size={12} color={'#ffffff'} loading={true}/>
                                    ||
                                    <img className={Styles.plusIconItem}
                                         src={require("../../assets/images/plus_sign_white_small.png")}/>
                                }
                            </div>
                        }
                        {
                            !this.state.customQuote.modal &&
                            <div>
                                {
                                    false &&
                                    <div className={
                                        cx(Styles.button,
                                            {
                                                [Styles.buttonActive]: Object.keys(this.state.selected).length > 3 || this.state.customQuote.saved,
                                            })
                                    } onClick={() => this._next()}>
                                        <div>{this._renderText("item_3")}</div>
                                    </div>
                                }
                                <div onClick={() => {
                                    if(this.state.inhouse){
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/slideshow")
                                    }else{
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang()+ "/" + salesChannelRegister.get('name') + "/signup/image")
                                    }
                                }}
                                     className={
                                         cx(Styles.backButton,
                                             {
                                                 [Styles.backButtonCenter]: true,
                                             })
                                     }>
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                        }
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width:"100%"}}/>
            </div>
        );
    }
}

export default SignupQuotes;


// WEBPACK FOOTER //
// ./src/pages/signup-quotes/component.js